import React from "react";
import { setUser as sentrySetUser } from "@sentry/react";
import i18n from "../services/translations/i18n";
import { ILoginContext } from "./loginContext.d";

export type { ILoginContext } from "./loginContext.d";

import Debug from "debug";
const debug = Debug("login:context");

// context: {account, accountId, user, userId, roles, entities}
/** @returns {{account: any, accountId: string; user: any; userId: string; roles: Array<string>; entities: Array<string>, isAdmin: boolean }} */
export const providerContext = ({
  account = {},
  currentUser,
  accountSettings = {}
}) => {
  sentrySetUser({
    id: currentUser?.id,
    username: currentUser?.name,
    accountId: account?.id,
    accountName: account?.name,
    entities: currentUser?.entities
  });

  const lang = currentUser?.preferences?.language;
  if (lang) {
    i18n.changeLanguage(lang, (err, t) => {
      if (err) return console.error(`change language ${lang} error`, err);
      console.log('load language to user preference ', lang);
    });
  }

  return {
    account: {
      ...account,
      hasFeature(feature) {
        debug("check if account has feature", feature);
        return (account?.features || []).includes(feature);
      },
      getType() {
        debug("return account type", account?.id);
        return account.type;
      }
    },
    accountId: account?.id,
    user: {
      ...currentUser,
      hasRole(role: string) {
        return (currentUser?.roles || []).includes(role)
      }
    },
    userId: currentUser?.id,
    roles: currentUser?.roles || [],
    entities: currentUser?.entities || [],
    isAdmin: (currentUser?.roles || []).includes("admin"),
    accountSettings
  };
};
const LoginContext = React.createContext<ILoginContext>(providerContext({}));

export const LoginProvider = LoginContext.Provider;
export default LoginContext;
